import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { DashboardCrecimentoSustentavel } from '../domain/dashboard-crescimento-sustentavel.model';

export class DashBoardCrescimentoSustentavelSerializer extends DomainSerializer<DashboardCrecimentoSustentavel> { }
